document.addEventListener("DOMContentLoaded", () => {
  // Navbar Color Change
  const rootStyles = getComputedStyle(document.documentElement);
  const initialNavbarStyles = {
    backgroundColor:
      rootStyles.getPropertyValue("--navbar-light-beige").trim() || "#fbf7f0",
    color:
      rootStyles.getPropertyValue("var(--brand--dark-grey)").trim() ||
      "#292929",
  };

  // Selecciona el <main> y verifica que exista
  const mainElement = document.querySelector("main");

  if (mainElement) {
    // Busca la primera .shopify-section dentro del <main>
    const firstShopifySection = mainElement.querySelector(".shopify-section");

    // Verifica si tiene un hijo con el atributo section-type="full-background"
    const hasFullBackground = firstShopifySection?.querySelector(
      '[section-type="full-background"]'
    );

    if (firstShopifySection && hasFullBackground) {
      // Busca el primer elemento dentro de la sección con estilo inline de color
      const inlineColorElement =
        firstShopifySection.querySelector("[style*='color']");

      if (inlineColorElement) {
        // Extrae el color del estilo inline
        const inlineStyle = inlineColorElement.getAttribute("style");
        const colorMatch = inlineStyle.match(/color:\s*([^;]+);/);

        if (colorMatch) {
          const sectionColor = colorMatch[1].trim(); // Extrae el color

          // Aplica inicialmente el color y fondo transparente a .navbar
          gsap.to(".navbar", {
            backgroundColor: "transparent",
            color: sectionColor,
            duration: 0.2,
          });

          // Selecciona la announcement-bar y calcula su altura original
          const announcementBar = document.querySelector("[announcement-bar]");
          console.log(announcementBar.offsetHeight)
          const originalHeight = announcementBar
            ? announcementBar.offsetHeight
            : 0;

          // Variable para controlar si la barra está oculta manualmente
          let isManuallyHidden = false;

          // Evento de click para esconder la announcement-bar
          const announcementBarBtn = document.querySelector(
            ".announcement-bar-btn"
          );
          if (announcementBarBtn && announcementBar) {
            announcementBarBtn.addEventListener("click", (e) => {
              e.preventDefault();
              isManuallyHidden = true; // Marca la barra como oculta manualmente

              gsap.to(announcementBar, {
                height: 0,
                duration: 0.3,
                ease: "power2.out",
                onComplete: () => {
                  announcementBar.style.display = "none"; // Esconde completamente
                },
              });
            });
          }

          // Agrega el evento de scroll
          window.addEventListener("scroll", () => {
            const scrollY = window.scrollY;

            if (scrollY === 0) {
              // Vuelve a aplicar valores de sección al estar en la parte superior
              gsap.to(".navbar", {
                backgroundColor: "transparent",
                color: sectionColor,
                duration: 0.2,
              });

              // Si la barra no ha sido ocultada manualmente, restaura su altura
              // if (!isManuallyHidden && announcementBar) {
              //   gsap.to(announcementBar, {
              //     height: originalHeight,
              //     duration: 0.3,
              //     ease: "power2.out",
              //     onStart: () => {
              //       announcementBar.style.display = "block"; // Asegura que sea visible
              //     },
              //   });
              // }
            } else {
              // Cambia a los valores iniciales al hacer scroll hacia abajo
              gsap.to(".navbar", {
                backgroundColor: initialNavbarStyles.backgroundColor,
                color: initialNavbarStyles.color,
                duration: 0.2,
              });

              // Reduce la altura del announcement-bar a 0
              // if (!isManuallyHidden && announcementBar) {
              //   gsap.to(announcementBar, {
              //     height: 0,
              //     duration: 0.3,
              //     ease: "power2.out",
              //   });
              // }
            }
          });
        } else {
          console.warn("No se encontró un color válido en el estilo inline.");
        }
      } else {
        console.warn(
          "No se encontró ningún elemento con estilo inline de color dentro de la sección."
        );
      }
    } else {
      console.warn(
        "No se encontró una .shopify-section dentro de <main> con un hijo que tenga section-type='full-background'."
      );
    }
  } else {
    console.warn("No se encontró el elemento <main> en el DOM.");
  }

  // Age Modal
  // Selecciona los elementos
  const modal = document.querySelector(".modal");
  const modalBg = document.querySelector(".modal-bg");
  const modalContent = document.querySelector(".modal-content");
  const confirmButton = document.querySelector("#confirm-age");

  // Mostrar el modal
  function showModal() {
    if (!modal) return;

    // Mostrar el modal
    modal.style.display = "flex";

    // Deshabilitar scroll del body
    document.body.style.overflow = "hidden";

    // Animación con GSAP
    gsap
      .timeline()
      .fromTo(
        modal,
        { opacity: 0 },
        { opacity: 1, duration: 0.3, ease: "power2.out" }
      ) // Animar opacidad del modal
      .fromTo(
        modalContent,
        { opacity: 0, scale: 0.9 },
        { opacity: 1, scale: 1, duration: 0.5, ease: "elastic.out(1, 0.5)" }
      ) // Animar contenido
      .add(() => {
        // Aplicar blur dinámicamente al fondo cuando la animación termine
        modalBg.style.backdropFilter = "blur(5px)";
        modalBg.style.webkitBackdropFilter = "blur(5px)";
      });
  }

  // Ocultar el modal
  function hideModal() {
    gsap
      .timeline()
      .to(modalContent, {
        opacity: 0,
        scale: 0.9,
        duration: 0.5,
        ease: "power2.in",
      }) // Animar contenido
      .to(modal, {
        opacity: 0,
        duration: 0.3,
        ease: "power2.in",
      }) // Animar opacidad del modal
      .add(() => {
        // Ocultar el modal y remover blur cuando termine la animación
        modal.style.display = "none";
        document.body.style.overflow = ""; // Restaurar scroll del body
        modalBg.style.backdropFilter = "none";
        modalBg.style.webkitBackdropFilter = "none";
      });
  }

  // Listener para cerrar el modal
  confirmButton.addEventListener("click", hideModal);

  // Llamada manual para probar
  showModal();
});
